import { UserTierType } from "@/constants/enums/user-tier-type.enum";
import {
  BasePermissions,
  isModulePermission,
} from "@/constants/permission-modules/base-permissions";
import { AllPermissions } from "@/constants/permission-modules/permissions";

const permissionHandler = () => {
  const isPermissionGranted = (
    permission: BasePermissions,
    userType: UserTierType,
    userPermissions: AllPermissions[],
  ): boolean => {
    // Check if the permission is in the user's permissions
    const tierPermissionName =
      `can_t${userType}_${permission}` as AllPermissions;
    if (
      !userPermissions?.length ||
      userPermissions?.includes?.(tierPermissionName)
    ) {
      return true;
    }

    return false;
  };

  return {
    isPermissionGranted,
  };
};

export default permissionHandler;
